import type { FC } from 'react';

import dynamic from 'next/dynamic';

import { TabPanel } from '@mui/lab';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';

import { t } from '@/utils/lang';
import type { EntityComponentProps } from '../../types/EntityComponent.types';
import CustomerInfo from './Detail/CustomerInfo';
import TabContainer from './Tabs/Common/TabContainer';

const Device = dynamic(() => import('./Tabs/Customer/Device'), {
    ssr: false,
});

const Assignee = dynamic(() => import('./Tabs/Customer/Assignee'), {
    ssr: false,
});

const CustomerEntityContent: FC<EntityComponentProps> = ({ data }) => {
    return (
        <Box>
            <CustomerInfo data={data} />
            <TabContainer
                defaultTab='device'
                tabPanels={
                    <>
                        <TabPanel value='device'>
                            <Device data={data} />
                        </TabPanel>
                        <TabPanel value='assignees'>
                            <Assignee customerId={data?.id} />
                        </TabPanel>
                    </>
                }
            >
                <Tab label={t('Thiết bị')} value='device' />
                <Tab label={t('Kỹ thuật viên')} value='assignees' />
            </TabContainer>
        </Box>
    );
};

export default CustomerEntityContent;
